import { createRequiredContext } from 'ha/core/RequiredContext';

import { IntlObject } from './types';

const IntlContext = createRequiredContext<IntlObject>('IntlContext');

export const IntlProvider = IntlContext.Provider;
export const IntlConsumer = IntlContext.Consumer;
export const useIntl = IntlContext.useContext;
